import '@ostrevent/scss/app-tourism.scss';
import { WpetListCpnt } from '@ostrevent/js/components/wpet_list';
import { WpetSingleCpnt } from '@ostrevent/js/components/wpet_single';

document.addEventListener( "DOMContentLoaded", function () {
    const ObjWpetListCpnt               = new WpetListCpnt();
    const ObjWpetSingleCpnt             = new WpetSingleCpnt();
});
